import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import CheckboxTsoPq from '@components/Checkbox/CheckboxTsoPq';
import { Box, ListItem, ListItemProps, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

type MenuListItemTspPqProps = {
  checkbox?: boolean;
  label: string;
  description?: string;
  active?: boolean;
  onClick?: () => void;
};

type StyledListItem = ListItemProps & { active: boolean };

const StyledTypographyContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    fontFamily: tsoPqTheme.typography.openSans,
    fontWeight: 400,
  };
});

const StyledLabel = styled(Typography)(() => {
  return {
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_medium,
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    lineHeight: '1.25rem',
  };
});

const StyledDescripiton = styled(Typography)(() => {
  return {
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_label_label_medium,
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    lineHeight: tsoPqTheme.typography.lineHeight_l,
  };
});

const StyledListItem = styled(ListItem, { shouldForwardProp: (prop) => prop !== 'active' })<StyledListItem>(({
  active,
}) => {
  return {
    minHeight: '2.625rem',
    cursor: 'pointer',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_com_gap_m,
    background: active ? tsoPqTheme.palette.background.primary.color_primary_background_bg_prim : 'transparent',
    padding: `${tsoPqTheme.spacingValues.atomSpacing.spacing_atom_padding_atom_padding_m} ${tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_8}`,
    '&: hover': { background: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_hover_lt },
    '&: active': { background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim },
  };
});

const MenuListItemTspPq = ({
  checkbox = false,
  label,
  description,
  active = false,
  onClick,
  ...props
}: MenuListItemTspPqProps) => {
  return (
    <StyledListItem active={active} onClick={onClick} {...props}>
      <StyledTypographyContainer>
        <StyledLabel>{label}</StyledLabel>
        {description && <StyledDescripiton>{description}</StyledDescripiton>}
      </StyledTypographyContainer>
      {checkbox && <CheckboxTsoPq />}
    </StyledListItem>
  );
};

export default MenuListItemTspPq;
